import { render, staticRenderFns } from "./ProductScore.vue?vue&type=template&id=198f2e73&scoped=true"
import script from "./ProductScore.vue?vue&type=script&lang=js"
export * from "./ProductScore.vue?vue&type=script&lang=js"
import style0 from "./ProductScore.vue?vue&type=style&index=0&id=198f2e73&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "198f2e73",
  null
  
)

component.options.__file = "ProductScore.vue"
export default component.exports